module.exports = __webpack_public_path__ + "d664201f/img/arrow-left-icon.785c715c.svg";